import { useCallback } from "react";
import { StringTransformer } from "@/features/ui/helpers/string-transformer";
import {
  LineSheetSetStatuses,
  LineSheetSetTypes,
} from "@/features/line-sheet-sets/line-sheet-set.types";
import { usePersistedQuery } from "@/features/order-sheet-sets/hooks/use-persisted-query";
import { ListLineSheetSetsRequest } from "@/features/line-sheet-sets/hooks/use-list-line-sheet-sets";

export interface BestSellingSectionQuery {
  brandIdsBs?: number[];
  isOrderable: boolean;
}

export default function usePersistedBestSellingQuery() {
  const { value, set, clear } = usePersistedQuery<BestSellingSectionQuery>({
    entries: {
      brandIdsBs: {
        parse: StringTransformer.parseIds,
        stringify: StringTransformer.stringifyIds,
      },
      isOrderable: {
        parse: StringTransformer.parseBoolean,
        stringify: StringTransformer.stringifyBoolean,
      },
    },
  });

  return { value, set, clear };
}
